import React from "react";
import { FaCaretDown, FaCaretRight } from "react-icons/fa";
import styled from "styled-components";
import { IOrganizationTree } from "../../../../../api/ResolveApi/resolve-api.types";
import OrgListName from "./OrgListName.component";

const OrganizationContainerDiv = styled.div<{ parent: boolean }>`
  display: grid;
  gap: 0 1.5rem;
  grid-template-columns: 0 20px 1fr;
  grid-template-rows: 35px 1fr;
  margin-top: ${({ parent }) => (parent ? `0` : `1.5rem`)};
  position: relative;
  width: 100%;
`;

const ChildIndicator = styled.div`
  align-self: center;
  background-color: ${({ theme }) => theme.colors.highlightLightGrey};
  height: 0.8px;
  justify-self: right;
  width: 25px;
`;

const ChildBar = styled.div`
  background-color: ${({ theme }) => theme.colors.highlightLightGrey};
  display: grid;
  grid-column: 2 / 3;
  height: calc(100% - 17px);
  justify-self: center;
  place-content: center;
  width: 1px;
`;

const ListIconDown = styled(FaCaretDown)`
  align-self: center;
  justify-self: center;
  transform: scale(1.2);
  fill: ${({ theme }) => theme.colors.highlightLightGrey};
`;

const ListIconRight = styled(FaCaretRight)`
  align-self: center;
  justify-self: center;
  transform: scale(1.2);
  fill: ${({ theme }) => theme.colors.highlightLightGrey};
`;

const OrganizationContainer: React.FC<IOrganizationTree> = props => {
  return (
    <OrganizationContainerDiv parent={props.organizationId === props.owner}>
      {/* First row */}
      {props.organizationId !== props.owner ? <ChildIndicator /> : <div />}
      {props.children.length > 0 ? <ListIconDown /> : <ListIconRight />}
      {props.displayName ? (
        <OrgListName
          name={props.displayName}
          organizationId={props.organizationId}
          isOrigin={props.organizationId === props.owner}
        />
      ) : (
        "An error occurred while trying to get the organization information."
      )}
      {/* Second row */}
      <ChildBar />
      <div>
        {props.children.map(child => (
          <OrganizationContainer {...child} key={child.organizationId} />
        ))}
      </div>
    </OrganizationContainerDiv>
  );
};

export default OrganizationContainer;
